'use client'
import {
  __spreadProps,
  __spreadValues
} from "./chunk-BTG5EALA.mjs";

// src/util/events.ts
var resolveContentfulEventType = (type) => {
  switch (type) {
    case "Package":
      return "packages";
    case "Restaurant":
      return "restaurants";
    case "Shows":
      return "shows";
    case "Experience":
      return "experiences";
    case "Auction":
      return "auctions";
    case "Zone":
      return "zones";
    default:
      return "events";
  }
};
var parseSectionItem = ({
  item,
  locale
}) => {
  var _a, _b, _c;
  const type = item == null ? void 0 : item.__typename;
  const urlType = resolveContentfulEventType(type);
  switch (type) {
    case "Event":
    case "Experience":
    case "Shows":
    case "Restaurant":
    case "Package":
    case "Auction":
      return __spreadProps(__spreadValues({}, item), {
        href: `/${locale}/${urlType}/${item.slug}`,
        label: item.cardButtonLabel,
        date: (_a = item.schedule) == null ? void 0 : _a.openScheduleText,
        background: item.image31
      });
    case "WebCard":
      return __spreadProps(__spreadValues({}, item), {
        date: item.subtitle,
        label: item.buttonLabel,
        image31: item.image31 || item.image,
        image11: item.image11 || item.image,
        background: item.image,
        isNew: item.isNew
      });
    case "Zone":
      return __spreadProps(__spreadValues({}, item), {
        label: (_b = item.button) == null ? void 0 : _b.label,
        date: (_c = item.schedule) == null ? void 0 : _c.openScheduleText,
        image31: item.banner || item.featuredBanner,
        image11: item.featuredBanner,
        href: `/${locale}/${urlType}/${item.slug}`,
        background: item.imageBg,
        eventType: "internal"
      });
    case "Category":
      return __spreadProps(__spreadValues({}, item), {
        href: `/${locale}/explore?category=${item.slug}`,
        image31: item.background || item.icon,
        image11: item.background || item.icon,
        icon: item.icon,
        isNew: item.isNew
      });
    case "Tag":
      return __spreadProps(__spreadValues({}, item), {
        href: `/${locale}/explore?tag=${item.slug}`,
        image31: item.background,
        image11: item.background,
        icon: item.icon,
        isNew: item.isNew
      });
    default:
      return null;
  }
};
var parseCardItem = ({ item }) => {
  const type = item == null ? void 0 : item.__typename;
  switch (type) {
    case "Event":
    case "Experience":
    case "Shows":
    case "Restaurant":
    case "Package":
    case "Auction":
      return item;
    case "Zone":
      return __spreadProps(__spreadValues({}, item), {
        image11: item.featuredBanner,
        image31: item.banner || item.featuredBanner
      });
    default:
      return null;
  }
};

export {
  resolveContentfulEventType,
  parseSectionItem,
  parseCardItem
};
//# sourceMappingURL=chunk-U4STZYNR.mjs.map